export const auth = {
  // Authentication
  welcome: 'Welcome',
  signInToAccess: 'Sign in to access your account',
  signInToAccount: 'Sign in to your account to continue',
  welcomeBack: 'Welcome Back',
  enterCredentials: 'Enter your credentials to access your account',
  login: 'Login',
  signup: 'Sign Up',
  email: 'Email',
  password: 'Password',
  fullName: 'Full Name',
  createAccount: 'Create Account',
  loginFailed: 'Login failed',
  signupFailed: 'Sign up failed',
  enterEmail: 'Enter your email',
  enterPassword: 'Enter your password',
  rememberMe: 'Remember me',
  keepMeLoggedIn: 'Keep me logged in',
  forgotPassword: 'Forgot password?',
  signingIn: 'Signing in...',
  orContinueWith: 'Or continue with',
  continueWithGoogle: 'Continue with Google',
  dontHaveAccount: 'Don\'t have an account?',
  alreadyHaveAccount: 'Already have an account?',
  signInHere: 'Sign in here',
  signIn: 'Sign In',
  
  // Signup
  joinKiraCar: 'Join KiraCar',
  createYourAccount: 'Create Your Account',
  chooseYourPath: 'Choose your path and start your journey with the best car rental platform',
  almostThere: 'Almost there! Let\'s set up your {{role}} account',
  customer: 'Customer',
  agency: 'Agency',
  admin: 'Admin',
  allRoles: 'All Roles',
  customerRoleTitle: 'I want to rent cars',
  customerAccount: 'Customer Account',
  customerRoleDescription: 'Browse and book amazing cars from verified agencies',
  customerDescription: 'Browse and book amazing cars from verified agencies',
  browseThousandsCars: 'Browse thousands of cars',
  instantBooking: 'Instant booking',
  securePayments: 'Secure payments',
  agencyRoleTitle: 'I want to rent out cars',
  agencyAccount: 'Agency Account',
  agencyRoleDescription: 'List your fleet and grow your rental business',
  agencyDescription: 'List your fleet and grow your rental business',
  listUnlimitedCars: 'List unlimited cars',
  manageBookings: 'Manage bookings',
  analyticsDashboard: 'Analytics dashboard',
  revenueTracking: 'Revenue tracking',
  startRentingToday: 'Start renting amazing cars today',
  growYourBusiness: 'Grow your rental business with us',
  change: 'Change',
  enterFullName: 'Enter your full name',
  enterPhone: 'Enter your phone number',
  createPassword: 'Create a strong password',
  confirmPassword: 'Confirm Password',
  confirmYourPassword: 'Confirm your password',
  creatingAccount: 'Creating Account...',
  createMyAccount: 'Create My Account',
  getStarted: 'Get Started',
  accountCreated: 'Account Created!',
  accountCreatedSuccess: 'Account created successfully! Please check your email to verify your account.',
  checkYourEmailForVerification: 'Please check your email to verify your account.',
  thankYouForJoining: 'Thank you for joining KiraCar! We\'ve sent a verification email to your inbox. Please click the link in the email to activate your account.',
  agencyCreatedSuccess: 'Agency created successfully! Welcome to KiraCar.',
  
  // Account Types
  selected: 'Selected',
  selectAccountType: 'Select Account Type',
  completeRegistration: 'Complete Registration',
  chooseAccountType: 'Choose your account type to get started',
  fillYourInformation: 'Fill in your information to complete registration',
  backToAccountChoice: 'Back to Account Choice',
  emailSentTo: 'Email sent to',
  agencySetupAfterVerification: 'You can set up your agency after email verification.',
  continueToSignIn: 'Continue to Sign In',
  
  // Form fields
  phone: 'Phone',
  
  // Forgot Password
  forgotPasswordTitle: 'Forgot Your Password?',
  forgotPasswordSubtitle: 'Enter your email address and we\'ll send you a link to reset your password',
  sendResetLink: 'Send Reset Link',
  sendingResetLink: 'Sending Reset Link...',
  rememberPassword: 'Remember your password?',
  backToLogin: 'Back to Login',
  resetLinkSent: 'Reset link sent to your email',
  checkEmailForReset: 'Please check your email for password reset instructions',
  checkSpamFolder: 'If you don\'t see the email, check your spam folder or try again with a different email address.',

  // Reset Password
  resetYourPassword: 'Reset Your Password',
  enterNewPassword: 'Enter your new password below',
  newPassword: 'New Password',
  enterNewPasswordPlaceholder: 'Enter new password',
  confirmNewPassword: 'Confirm New Password',
  confirmNewPasswordPlaceholder: 'Confirm new password',
  updatePassword: 'Update Password',
  updatingPassword: 'Updating Password...',
  passwordResetSuccessfully: 'Password Reset Successfully',
  passwordUpdatedRedirecting: 'Your password has been updated. Redirecting to login...',
  canUseNewPassword: 'You can now use your new password to sign in to your account.',
  
  // Email Confirmation Page
  emailConfirmationRequired: 'Email Confirmation Required',
  emailConfirmationInstructions: 'To complete your agency registration, please:',
  emailConfirmationStep1: 'Check your email inbox for a confirmation message',
  emailConfirmationStep2: 'Click the confirmation link in the email',
  emailConfirmationStep3: 'Return here to complete your agency setup',
  emailConfirmationHelp: 'Don\'t see the email? Check your spam folder or try refreshing after confirming.',
  iveConfirmedMyEmail: 'I\'ve Confirmed My Email',
  checking: 'Checking...',
  
  // Agency Setup Page
  verifyingYourAccount: 'Verifying Your Account',
  pleaseWaitWhileChecking: 'Please wait while we check your account status...',
  authenticationRequired: 'Authentication Required',
  needToBeSignedIn: 'You need to be signed in to set up your agency. Please sign in with your confirmed account.',
  accessDenied: 'Access Denied',
  onlyAccessibleToAgency: 'This page is only accessible to agency users. Please sign up as an agency to access this feature.',
  signUpAsAgency: 'Sign Up as Agency',
  agencyAlreadySetUp: 'Agency Already Set Up',
  agencyAccountConfigured: 'Your agency account is already configured. You can access your dashboard directly.',
  goToDashboard: 'Go to Dashboard',
  setupRequired: 'Setup Required',
  failedToVerifyAccount: 'Failed to verify your account status.',

  // Agency Registration Form
  pleaseSignInToContinue: 'Please sign in to continue with agency registration.',
  authCheckFailed: 'Authentication check failed. Please try again.',
  authFailed: 'Authentication failed. You may need to sign in again.',
  pleaseSelectValidImage: 'Please select a valid image file',
  pleaseFillAllRequired: 'Please fill in all required fields',
  failedToCreateAgency: 'Failed to create agency. Please try again.',
  enterAgencyName: 'Enter your agency name',
  briefDescription: 'Brief description of your car rental business...',
  backToSignup: 'Back to Signup',
  previous: 'Previous',
  confirmClearProgress: 'Are you sure you want to go back? Your progress will be saved and you can continue later.',
  autoSaved: 'Auto-saved',

  // Agency Registration Form - Step Content
  agencyInformation: 'Agency Information',
  letsSetupAgencyProfile: 'Let\'s set up your rental agency profile',
  stepOfFour: 'Step {{step}} of 4',
  percentComplete: '{{percent}}% Complete',
  settingUpSession: 'Setting up your session...',
  pleaseWaitPreparing: 'Please wait while we prepare your agency registration.',
  
  // Step 1 - Basic Information
  agencyName: 'Agency Name',
  businessEmail: 'Business Email',
  businessPhone: 'Business Phone',
  businessDescription: 'Business Description',
  website: 'Website',
  websiteOptional: 'Website (Optional)',
  
  // Step 2 - Location Information
  streetAddress: 'Street Address',
  city: 'City',
  cityPlaceholder: 'Enter city',
  cityAutoFilled: 'City is automatically filled when you select an address',
  country: 'Country',
  agencyLogo: 'Agency Logo',
  agencyLogoOptional: 'Agency Logo (Optional)',
  uploadAgencyLogo: 'Upload your agency logo (Max 5MB)',
  chooseFile: 'Choose File',
  selectCountry: 'Select Country',
  
  // Step 3 - Business Settings
  currency: 'Currency',
  taxRate: 'Tax Rate (%)',
  operatingHours: 'Operating Hours',
  openingTime: 'Opening Time',
  closingTime: 'Closing Time',
  openAlways: 'Open 24/7',
  openAlwaysDescription: 'Your agency is open continuously, 24 hours a day and 7 days a week',
  openAllDay: 'Open 24/7',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  closed: 'Closed',
  to: 'to',
  
  // Step 4 - Review
  location: 'Location',
  businessSettings: 'Business Settings',
  name: 'Name',
  description: 'Description',
  
  // Navigation
  next: 'Next',
  createAgency: 'Create Agency',
  creatingAgency: 'Creating Agency...',
  
  // Placeholders
  businessEmailPlaceholder: 'business@example.com',
  businessPhonePlaceholder: '+212 5XX-XX-XX-XX',
  websitePlaceholder: 'https://www.yourwebsite.com',
  streetAddressPlaceholder: '123 Main Street',
  taxRatePlaceholder: '0.0',
  
  // Validation messages
  pleaseFillAllFields: 'Please fill in all required fields',
  logoFileSizeTooLarge: 'Logo file size must be less than 5MB',

  // Error messages
  emailNotConfirmed: 'Email not confirmed. Please check your email and click the verification link.',
  invalidCredentials: 'Invalid email or password. Please try again.',
  accountNotFound: 'Account not found. Please check your email or sign up.',
  passwordTooWeak: 'Password must be at least 6 characters long.',
  emailAlreadyExists: 'An account with this email already exists.',
  unexpectedError: 'An unexpected error occurred. Please try again.',
  fillAllFields: 'Please fill in all required fields.',
  passwordsDoNotMatch: 'Passwords do not match.',
  invalidEmail: 'Please enter a valid email address.',
  passwordTooShort: 'Password must be at least 6 characters long',
  invalidExpiredLink: 'Invalid or expired reset link. Please request a new one.',
  unexpectedErrorTryAgain: 'An unexpected error occurred. Please try again.',
  checkingResetLink: 'Checking reset link...',
  processingRecoveryLink: 'Processing recovery link, please wait...',
  
  // Login specific messages
  loginSuccess: 'Login successful! Redirecting...',
  loginError: 'Login failed. Please check your credentials and try again.',
  loginTimeout: 'Login timed out. Please check your internet connection and try again.',
  slowConnection: 'Connection is slow, please wait...',
  initializing: 'Initializing application...',
  retry: 'Retry',
  proceedAnyway: 'Proceed Anyway',
  orSignUp: 'Or sign up',
  
  // Account linking messages
  accountExistsSignIn: 'An account with this email already exists. Please sign in instead.',
  googleAccountSignIn: 'This email is associated with a Google account. Please sign in with Google or create a password for this account.',
  accountLinkingFailed: 'Failed to link account. Please try signing in with Google or contact support.',
  
  // Dashboard
  signOut: 'Sign Out',
  
  // Email verification check
  iveVerifiedMyEmail: 'I\'ve Verified My Email',
  emailNotYetVerified: 'Email not yet verified. Please click the link in your email before continuing.',
  emailVerifiedSuccessfully: 'Email verified successfully! Complete your agency setup now.',
  errorDuringVerification: 'Error during verification. Please try again.',
  agencyConfigurationTitle: 'Agency Configuration',
  agencyConfigurationMessage: 'You must first verify your email by clicking the link sent. After verification, use the button below to access your agency configuration.',
  accountCreatedSuccessTitle: 'Account Created Successfully!',
  checkEmailToActivate: 'Check your email to activate your account',
  verificationEmailSent: 'Verification email sent',
  verificationEmailSentTo: 'We have sent a verification email to:',
  nextSteps: 'Next steps:',
  openEmailInbox: 'Open your email inbox',
  lookForKiraCarEmail: 'Look for the KiraCar email',
  clickVerificationLink: 'Click on the verification link',
  accountWillBeActivated: 'Your account will be activated automatically',
  dontSeeEmail: 'Don\'t see the email? Check your spam or junk folder.',
  createAnotherAccount: 'Create Another Account',
  
  // Email verification page
  emailVerificationRequired: 'Email Verification Required',
  pleaseVerifyYourEmail: 'Please verify your email to sign in',
  checkYourEmailToVerify: 'Check your email to verify your account',
  verifyEmailToLogin: 'Verify your email to continue with login',
  verifyEmailBeforeLogin: 'Please verify your email address before you can sign in to your account.',
  clickLinkInEmail: 'Click the verification link in your email',
  checkSpamIfNotFound: 'Don\'t see it? Check your spam folder',
  returnHereToCheckVerification: 'Return here to check verification',
  resendVerificationEmail: 'Resend Verification Email',
  resending: 'Resending...',
  resendIn: 'Resend in {{seconds}} seconds',
  verificationEmailResent: 'Verification email resent! Check your inbox.',
  
  // Email confirmed page
  emailConfirmedSuccessfully: 'Email confirmed successfully!',
  accountActivatedSuccessfully: 'Your account has been activated successfully',
  readyToSetupAgency: 'You are now ready to set up your agency',
  welcomeToKiraCarPlatform: 'Welcome to KiraCar platform',
  nextStepAgencySetup: 'Next step: Agency Setup',
  nextStepExplore: 'Next step: Explore KiraCar',
  setupAgencyDetails: 'Set up your agency details and start managing your vehicles',
  discoverOurVehicles: 'Discover our wide range of vehicles available for rent',
  setupMyAgency: 'Set up my agency',
  exploreKiraCar: 'Explore KiraCar',
  welcomeToKiraCar: 'Welcome to KiraCar!',
  preparingYourAccount: 'Preparing your account...',
  profileNotFound: 'Account setup incomplete. Please contact support.',
  goToHome: 'Go to Home',
  
  // Booking Authentication
  signInToBook: 'Sign In to Book',
  signInToBookDescription: 'Please sign in to continue with your car booking',
  createAccountToBook: 'Create Account to Book',
  createAccountToBookDescription: 'Create an account to complete your car booking',
  signupSuccess: 'Account created successfully!',
  checkEmailForVerification: 'Please check your email to verify your account.',
  backToAccountType: 'Back to Account Type',
  
  // Status Messages
  signUp: 'Sign Up',
  
  // Unauthorized access
  unauthorized: {
    title: 'Access Denied',
    requiresAccount: 'This dashboard requires an account with the following role:',
    currentlyLoggedAs: 'You are currently logged in as:',
    loginDifferentAccount: 'Login with Different Account',
    signOutAndLogin: 'Sign Out & Login',
    loginWithCorrectAccount: 'Login with Correct Account',
    backToHome: 'Back to Home',
    needHelp: 'Need help?',
    contactSupport: 'Contact Support'
  },
  
  // User roles
  roles: {
    admin: 'Administrator',
    agency: 'Agency',
    customer: 'Customer',
    adminDescription: 'Full system access and management',
    agencyDescription: 'Manage vehicles, bookings, and clients',
    customerDescription: 'Browse and book vehicles'
  },
  
  signingOut: 'Signing out...',
  backToHome: 'Back to Home',
  
  // Auth Callback
  signingYouIn: 'Signing you in...',
  pleaseWaitWhileWeSignYouIn: 'Please wait while we sign you in and redirect you to your dashboard',
  
  // Top Bar Links
  imAClient: "I'm a Client",
  imAnAgency: "I'm an Agency"
}; 